import React from 'react';
import { Link } from 'react-router-dom';

const Gallery: React.FC = () => {
  const galleryItems = [
    {
      id: 1,
      title: 'Museo Textiles',
      category: 'Heritage',
      image: '/images/Buy Clothing Fabrics by Category, Online Shop - SK Textiles/imgi_20_CHIFFON-WOVEN_WHITE_YS135Z150-03000-450x450.jpg',
      height: 'h-64',
      gradient: 'from-royal-purple to-amethyst'
    },
    {
      id: 2,
      title: 'Chintz Collection',
      category: 'Traditional',
      image: '/images/Print Fabrics – Lively Fabrics/imgi_28_9168bb4e-1d43-4a2c-8fb8-cc7c516f0caa.jpg',
      height: 'h-80',
      gradient: 'from-warm-gold to-sunset-orange'
    },
    {
      id: 3,
      title: 'Damask Patterns',
      category: 'Luxury',
      image: '/images/Caversham Textiles and Designs – Modern South African Designs/imgi_136_HC-Whole-Fig-Tea-Towel-02-SQ.jpg',
      height: 'h-72',
      gradient: 'from-coral to-rose-500'
    },
    {
      id: 4,
      title: 'Chenille Fabric',
      category: 'Texture',
      image: '/images/Plain-Mini-Matt-Fabrics/imgi_221_MiniMatt_Colour07_Twist-Edit.jpg',
      height: 'h-96',
      gradient: 'from-ocean-blue to-teal-wave'
    },
    {
      id: 5,
      title: 'Fire-retardant',
      category: 'Technical',
      image: '/images/The Stain Guard Range™️_ Protection🍷 – Ragland Fabrics/imgi_259_MarsalaTS.png',
      height: 'h-64',
      gradient: 'from-deep-purple to-royal-purple'
    },
    {
      id: 6,
      title: 'Polo T-shirt',
      category: 'Apparel',
      image: '/images/Online Clothing Fabrics Shop - Vega Textiles/imgi_149_IMG_1320.jpg',
      height: 'h-80',
      gradient: 'from-sky-blue to-ocean-blue'
    }
  ];

  return (
    <section className="section-padding bg-gradient-accent">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gradient mb-6">
            Latest Projects
          </h2>
          <p className="text-xl text-sage max-w-3xl mx-auto">
            A glimpse into our creative process and the stories behind each textile creation.
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {galleryItems.map((item) => (
            <div
              key={item.id}
              className={`${item.height} break-inside-avoid group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500`}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              
              {/* Enhanced Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-midnight/80 via-deep-purple/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <span className={`inline-block bg-gradient-to-r ${item.gradient} text-white px-4 py-2 text-sm font-medium rounded-full mb-3 shadow-lg`}>
                    {item.category}
                  </span>
                  <h3 className="text-xl font-serif font-semibold mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-200">
                    Discover the craftsmanship behind this exceptional textile.
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <Link to="/collections" className="btn-outline hover:scale-105 transition-transform duration-300">
            View Full Portfolio
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
